var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.1855,
    width: 80,
    height: 80,
    rx: 10,
    transform: "rotate(15 21.1855 0)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_4466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1496 25.0077L59.0335 22.5651L49.1609 59.4102C47.9845 63.8004 43.5122 66.467 39.1489 65.2979C34.7857 64.1288 32.2458 59.5832 33.4221 55.193C34.5774 50.8814 38.9509 48.2722 43.2004 49.2429L45.679 39.9924C36.3651 37.6647 26.8478 43.2648 24.3061 52.7504C21.7434 62.3146 27.3205 72.0431 36.7482 74.5692C46.1758 77.0954 55.891 71.3803 58.4327 61.8946L63.4951 43.0017C66.2512 46.4289 70.0594 49.0458 74.4796 50.3142L76.9582 41.0637C70.1648 38.9913 66.3011 31.9064 68.1496 25.0077Z",
    fill: "#EE5A02"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_4466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(29.6709 14.6973) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d61cd6ce9188f1ed77bb320052f1405a.svg";
export { ForwardRef as ReactComponent };